import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'
import { switchFSM } from '../../util/productHandler'
import DebugWrapper from './DebugWrapper'
import { SwitchFSMParamsType } from '../../types/interface/fsm.interface'
import { FSMCommonTransitions } from '../../FSM/shared/constants'
import { FlowName, IS_ACCEPTANCE, IS_PRODUCTION } from '../../config'
import { ProductName } from '../../types/interface/quote.interface'
import { ERROR_TYPE, ErrorCode } from '../../constants'
import Icon from '@mui/material/Icon'

const useStyles = makeStyles()((theme: Theme) => ({
  btnDebug: {
    position: 'absolute',
    top: 14,
    right: 0,
    color: theme.palette.primary.main,
    zIndex: 1000,
  },

  icon: {
    color: theme.brand.colors.main,
  },
}))

// Navigates to selected product flow page for DEBUG QA needs on DEV
const SwitchFlowDEVButton = (params: SwitchFSMParamsType) => {
  const { classes } = useStyles()
  const { targetProduct, targetFlow, label = `Switch to ${targetFlow}/${targetProduct}` } = params

  const switchClickHandler = () => {
    const targetStateValue =
      (prompt(
        'Select targetState (see FSMCommonTransitions). Examples: "quoteFind", "policies", "error":',
        typeof params.targetStateValue === 'string'
          ? params.targetStateValue
          : JSON.stringify(params.targetStateValue)
      ) as FSMCommonTransitions) || FSMCommonTransitions.AUTH
    const targetFlow =
      (prompt(
        'Select targetFlow (see FlowName). Examples: "qb", "mypages":',
        params.targetFlow
      ) as FlowName) || FlowName.QUOTE_AND_BUY
    const targetProduct =
      (prompt(
        'Select targetProduct (see ProductName). Examples: "vehicle", "travel", "content":',
        params.targetProduct
      ) as ProductName) || ProductName.VEHICLE

    // Switching to "error" needs an `errorType` in context, or ErrorPage falls back to the
    // generic message — prompt for the code (see ErrorCode in error-constants.ts) in that case.
    const contextOverride =
      targetStateValue === FSMCommonTransitions.ERROR
        ? {
            ...params.contextOverride,
            errorType:
              ERROR_TYPE[
                Number(
                  prompt(
                    'Select errorCode (see ErrorCode). Examples: 2000 (constraints), 1002 (validation), 20010 (no quote), 1000 (general):',
                    String(ErrorCode.ERROR_CODE_QUOTE_CONSTRAINTS)
                  )
                ) as ErrorCode
              ],
          }
        : params.contextOverride

    switchFSM({ ...params, targetStateValue, targetFlow, targetProduct, contextOverride })
  }

  return !IS_PRODUCTION && !IS_ACCEPTANCE ? (
    <DebugWrapper>
      <Button className={classes.btnDebug} onClick={switchClickHandler}>
        <Icon className={classes.icon} fontSize='large' title={label}>
          logo_dev
        </Icon>
        <Icon className={classes.icon} fontSize='large' title={label}>
          switch_access_shortcut
        </Icon>
      </Button>
    </DebugWrapper>
  ) : null
}

export default SwitchFlowDEVButton
